import React from 'react';
import { StyledBannersContainer } from './BannersSection.styled';
import { StyledSectionTitle, StyledSectionSubtitle, StyledPaperContainer } from '../../PlusWebsiteEditor.styles';
import BannersEditor from '../../components/BannersEditor/BannersEditor';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { Banner as IBanner } from '../../types/banners';
import { ArrayErrorGetter, BlurHandler, ChangeHandler } from '../../types/handlers';

type Props = {
  banners: WebsiteConfiguration['banners'];
  onChange: ChangeHandler<Array<IBanner>>;
  onBlur: BlurHandler;
  getError: ArrayErrorGetter<IBanner>;
};

const BannersSection = ({ banners = [], onChange, onBlur, getError }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Banners</StyledSectionTitle>
    <StyledSectionSubtitle>Banners support JPEG and PNG Image formats. The banner size is 343px x 220px at 3X.</StyledSectionSubtitle>
    <StyledBannersContainer>
      <BannersEditor getError={getError} onBlur={onBlur} items={banners} onChange={onChange} />
    </StyledBannersContainer>
  </StyledPaperContainer>
);

export default BannersSection;
